import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const ResellerLoginPage = () => {
  const navigate = useNavigate();
  const [tab, setTab] = useState<"login" | "apply">("login");
  const [form, setForm] = useState({ email: "", password: "", name: "", platform: "", handle: "", paypal: "" });

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    navigate("/reseller/dashboard");
  };

  const handleApply = (e: React.FormEvent) => {
    e.preventDefault();
    navigate("/reseller/dashboard");
  };

  return (
    <div className="min-h-screen bg-[#f8f7f5] flex items-center justify-center p-4" style={{ fontFamily: "'Inter', sans-serif" }}>
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex flex-col items-center gap-2">
            <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#D4AF37] to-[#B8860B] flex items-center justify-center">
              <i className="ri-vip-crown-fill text-white text-2xl"></i>
            </div>
            <div>
              <div className="font-extrabold text-gray-900 text-lg">Crown Prime Mall</div>
              <div className="text-[#D4AF37] text-xs font-semibold">Reseller Portal</div>
            </div>
          </Link>
        </div>

        <div className="bg-white rounded-xl border border-gray-100 overflow-hidden">
          {/* Tabs */}
          <div className="flex border-b border-gray-100">
            <button
              onClick={() => setTab("login")}
              className={`flex-1 py-3.5 text-sm font-semibold transition-colors cursor-pointer ${
                tab === "login" ? "text-[#C41E3A] border-b-2 border-[#C41E3A]" : "text-gray-400 hover:text-gray-600"
              }`}
            >
              Reseller Login
            </button>
            <button
              onClick={() => setTab("apply")}
              className={`flex-1 py-3.5 text-sm font-semibold transition-colors cursor-pointer ${
                tab === "apply" ? "text-[#C41E3A] border-b-2 border-[#C41E3A]" : "text-gray-400 hover:text-gray-600"
              }`}
            >
              Apply to Join
            </button>
          </div>

          <div className="p-6">
            {tab === "login" ? (
              <form onSubmit={handleLogin} className="space-y-4">
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1.5">Email Address</label>
                  <input
                    type="email"
                    value={form.email}
                    onChange={(e) => setForm({ ...form, email: e.target.value })}
                    placeholder="your@email.com"
                    className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#C41E3A] transition-colors"
                    required
                  />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1.5">Password</label>
                  <input
                    type="password"
                    value={form.password}
                    onChange={(e) => setForm({ ...form, password: e.target.value })}
                    placeholder="••••••••"
                    className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#C41E3A] transition-colors"
                    required
                  />
                </div>
                <button
                  type="submit"
                  className="w-full bg-[#C41E3A] text-white py-3 rounded-lg font-bold text-sm hover:bg-[#a01830] transition-colors cursor-pointer whitespace-nowrap"
                >
                  Sign In to Dashboard
                </button>
                <div className="text-center text-xs text-gray-400">
                  Not a reseller yet?{" "}
                  <button type="button" onClick={() => setTab("apply")} className="text-[#C41E3A] font-semibold cursor-pointer">
                    Apply to join
                  </button>
                </div>
              </form>
            ) : (
              <form onSubmit={handleApply} className="space-y-4">
                <div className="bg-[#D4AF37]/10 rounded-lg p-3 mb-2">
                  <div className="flex items-center gap-2 text-[#B8860B] text-xs font-semibold">
                    <i className="ri-information-line"></i>
                    Open to TikTok, Instagram &amp; YouTube stars
                  </div>
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1.5">Full Name</label>
                  <input
                    type="text"
                    value={form.name}
                    onChange={(e) => setForm({ ...form, name: e.target.value })}
                    placeholder="Your full name"
                    className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#C41E3A] transition-colors"
                    required
                  />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1.5">Email Address</label>
                  <input
                    type="email"
                    value={form.email}
                    onChange={(e) => setForm({ ...form, email: e.target.value })}
                    placeholder="your@email.com"
                    className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#C41E3A] transition-colors"
                    required
                  />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1.5">Primary Platform</label>
                  <select
                    value={form.platform}
                    onChange={(e) => setForm({ ...form, platform: e.target.value })}
                    className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#C41E3A] transition-colors bg-white"
                    required
                  >
                    <option value="">Select your platform</option>
                    <option value="TikTok">TikTok</option>
                    <option value="Instagram">Instagram</option>
                    <option value="YouTube">YouTube</option>
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1.5">Your Handle / Channel</label>
                  <input
                    type="text"
                    value={form.handle}
                    onChange={(e) => setForm({ ...form, handle: e.target.value })}
                    placeholder="@yourhandle"
                    className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#C41E3A] transition-colors"
                    required
                  />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1.5">PayPal Email (for commission payouts)</label>
                  <input
                    type="email"
                    value={form.paypal}
                    onChange={(e) => setForm({ ...form, paypal: e.target.value })}
                    placeholder="paypal@email.com"
                    className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#C41E3A] transition-colors"
                    required
                  />
                </div>
                <button
                  type="submit"
                  className="w-full bg-[#C41E3A] text-white py-3 rounded-lg font-bold text-sm hover:bg-[#a01830] transition-colors cursor-pointer whitespace-nowrap"
                >
                  Submit Application
                </button>
                <div className="text-center text-xs text-gray-400">
                  Already approved?{" "}
                  <button type="button" onClick={() => setTab("login")} className="text-[#C41E3A] font-semibold cursor-pointer">
                    Sign in
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>

        <div className="text-center mt-4">
          <Link to="/" className="text-xs text-gray-400 hover:text-gray-600 transition-colors cursor-pointer">
            &larr; Back to Crown Prime Mall
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ResellerLoginPage;
